import { render, staticRenderFns } from "./StudentBalanceCard.vue?vue&type=template&id=3d962c23&"
import script from "./StudentBalanceCard.vue?vue&type=script&lang=ts&"
export * from "./StudentBalanceCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports